// extracted by mini-css-extract-plugin
var _1 = "ttqwNIvm";
export { _1 as "container" }
